<template>
  <div class="header-tools__wrapper">
    <BaseButton2
      class="header__burger"
      @click="() => openMenu()"
    >
      <BaseIcon2
        id="icon-burger"
        height="24"
        width="24"
      />
    </BaseButton2>

    <BaseLink
      class="header__logo-wrapper"
      :href="`/${locale}/client/projects?force=true`"
    >
      <img
        alt=""
        class="header__logo"
        src="/logos/logo.svg"
      />
      MyDonut
    </BaseLink>

    <BaseLink
      class="header__help ui-link-secondary"
      :href="`/${locale}/faq`"
    >
      <span v-html="t('header.help')" />
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n();
const { toggleMenuCabinet } = useAppStore();

const openMenu = () => {
  toggleMenuCabinet(true);
  pageScrollBlock();
};
</script>

<style scoped>
.header-tools__wrapper {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 8px;
}

@media (--desktop) {
  .header-tools__wrapper {
    column-gap: 40px;
  }
}

.header__logo-wrapper {
  display: flex;
  align-items: center;
  font-family:
    Plus Jakarta Sans,
    Inter,
    system-ui,
    -apple-system,
    sans-serif;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
}

.header__logo {
  justify-content: center;
  height: 25px;
  width: 25px;
}

@media (--desktop) {
  .header__logo-wrapper {
    font-size: 20px;
    font-weight: 700;
    gap: 12px;
  }

  .header__logo {
    height: 40px;
    width: 40px;
  }
}

.header__help {
  display: none;
}

@media (--desktop) {
  .header__help {
    display: block;
    flex-shrink: 0;
  }
}

.header__burger {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  color: var(--orange-1);
}

@media (--desktop) {
  .header__burger {
    display: none;
  }
}
</style>
